/**
 * Site entry point module. Require modules for components
 * that don't exist on the global scope.
 */

import './modernizr.js'

import { addStyledComponentStyles } from './modules/helper-functions'

// Required components.
import whenDomReady from 'when-dom-ready'
import loadWebFonts from './modules/webfonts'

// Import components etc.
import initLangMenu from '../components/language-menu/language-menu'
import initCarousel from '../components/carousel/carousel'
import initSlidesCarousel from '../components/slides-carousel/slides-carousel'
import initGuidesCarousel from '../components/guides-carousel/guides-carousel'
import initGuideDownload from '../components/guide-download/guide-download'
import initVimeoVideo from '../components/vimeo-video/vimeo-video'
import initPropertyContactCarousel from '../components/property-contact-persons/property-contact-persons'
import initPropertyGallery from '../components/property-gallery/property-gallery'
import initPropertyNavigation from '../components/property-navigation/property-navigation'
import initArchiveFilters from '../components/archive-filters/archive-filters'
import initAjaxPostsList from '../components/ajax-filter-post-list/ajax-filter-post-list'
import initShoppingCenterLocation from '../components/shopping-center-location/shopping-center-location'
import initSlideNav from '../components/slide-nav/slide-nav'
import initModalNav from '../components/modal-navigation/modal-navigation'
import initPropertySpaces from '../components/property-spaces/property-spaces'
import initBuildingServices from '../components/property-building-services/property-building-services'
import initEnvironmenCcertificates from '../components/property-environment-certificates/property-environment-certificates'
import initContactPersonBar from '../components/contact-person-bar/contact-person-bar'
import initLocationHighlights from '../components/location-highlights/location-highlights'
import initExtranetToolbar from '../components/extranet-toolbar/extranet-toolbar'
import initSiblingNav from '../components/sibling-navigation/sibling-navigation'
import initSinglePostContent from '../components/single-post-content/single-post-content'
import propertiesCarousel from '../components/properties-carousel/properties-carousel'
import contactPersonCard from '../components/contact-person-card/contact-person-card'
import propertiesMap from '../components/properties-map/properties-map'
import contactPersons from '../components/contact-persons/contact-persons'
import contactForm from '../components/contact-form/contact-form'
import peopleGallery from '../components/people-gallery/people-gallery'
import propertySearchResults from '../components/property-search-results/property-search-results'

import initPropertySpace from './templates/single-property-space'

// Init stuff that doesn't need to wait for DOM to be ready.
loadWebFonts()

/**
 * Execute functions that need to wait until the DOM is ready.
 * Try tu put as little as possible here. The earlier, the better.
 */
whenDomReady().then(() => {

  // Remove the preload class that prevents all transitions.
  document.body.classList.remove( 'preload' )

  // Initialize components.
  initLangMenu()
  initCarousel()
  initSlidesCarousel()
  initGuidesCarousel()
  initGuideDownload()
  initVimeoVideo()
  initPropertyContactCarousel()
  initPropertyGallery()
  initPropertyNavigation()
  initArchiveFilters()
  initAjaxPostsList()
  initShoppingCenterLocation()
  initSlideNav()
  initModalNav()
  addStyledComponentStyles()
  initPropertySpaces()
  initBuildingServices()
  initEnvironmenCcertificates()
  initContactPersonBar()
  initLocationHighlights()
  initExtranetToolbar()
  initSiblingNav()
  initSinglePostContent()
  propertiesCarousel()
  contactPersonCard()
  propertiesMap()
  contactPersons()
  contactForm()
  peopleGallery()
  propertySearchResults()

  initPropertySpace()
})
